enum FilterByLetterEnum {
	C = 'C',
	D = 'D',
	O = 'O',
	P = 'P',
	R = 'R',
	N = 'N',
}

export {FilterByLetterEnum};
